export const uid = (): string => String(Math.floor(Math.random() * 10000))
